export const BASE_URL = process.env.REACT_APP_BASE_URL + "/api/v1";
export const ADMIN_BASE_URL = process.env.REACT_APP_BASE_URL + "/api/v1/admins";
export const SKETCH_SCAN_URL = "https://lanky-ill-funny-testnet.explorer.testnet.skalenodes.com/";
export const IMG_CDN_URL = "https://cdn.sketchproject.io";
